import { Card, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    card: {
        opacity: 1,
        transition: 'all 0.3s ease 0s',
        MozTransition: 'all 0.3s ease 0s',
        WebkitTransition: 'all 0.3s ease 0s',
        height: "100%",
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.9,
            transition: 'all 0.3s ease 0s',
            MozTransition: 'all 0.3s ease 0s',
            WebkitTransition: 'all 0.3s ease 0s'
        }
    },
}));

interface Props {
    id: number;
    name: string;
    shortDescription: string;
    imageUrl: string;
    detailPageUrl: string
}

export function PremiumContentListCard(props:Props){
    const { id, name, shortDescription, detailPageUrl, imageUrl } = props;
    const history = useHistory();
    const classes = useStyles();

    return (
        <Grid item key={id} xs={12} sm={3}>
            <Card className={classes.card} onClick={() => history.push(detailPageUrl)} >
                <img alt="Premium Sermon" width="100%" src={imageUrl} onError={(e) => e.currentTarget.setAttribute('src', "//i.cdn-sc.com/Logos/SermonMaker_384x216.jpg")}/>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {name}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {shortDescription}
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}